import Share from '../../src/legacy/Share.tsx';
export default Share;
